

(function($){
	
		
	/*
		
		TODO: POPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUP
		TODO: POPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUP
		TODO: POPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUPPOPUP
		
		====
		
		newsletter popup
		
		shipping popup
		
		messaging popup
		
		product ajax
		
	*/
	
	$.cookie.defaults = { path: '/' }; // in the main
	
	var Popup = {
		
		init: function(){
			
			var __this = this;
			
			this.popupProduct = null;
			
			this.popupNewsletter = null;
			
			//$.removeCookie( 'data-product' ); $.removeCookie( 'data-newsletter' ); 
			
			this.setupProduct();
			
			this.setupCart();
			
			this.setupCollection();
			
			this.setupNewsletter();
			
			this.setupShipping();
			
			this.setupGeneral();
			
			this.testPopups();
			
			//$( '<div style="display: block; background: black; color: #fff;" id="force-popup">FORCE POPUP</div>' ).appendTo( 'body' );
			
			if( $( '#force-popup' ).length ){ 
				
				$( '#force-popup' ).click( function(){
				
					 __this.testPopups( 1 );
					
				} )
				
			}
			
		},
		
		setupCart: function(){
			
			var __this = this;
			
			intEl = $( 'meta[ data-cart ]' ); 
			
			if ( intEl.length ) {
				
				this.popupCart = intEl.first();
				
				this.popupCart.data( 'data-cart', this.popupCart );
				
				$.extend( this.popupCart, PopupCart );
				
				this.popupCart.init( __this );
				
			}
			
		},
		
		setupProduct: function(){
			 
			var __this = this;
			
			intEl = $( 'meta[ data-product ]' ); 
			
			if ( intEl.length ) {
				
				this.popupProduct = intEl.first();
				
				this.popupProduct.data( 'data-product', this.popupProduct );
				
				$.extend( this.popupProduct, PopupProduct );
				
				this.popupProduct.init( __this );
				
			}
			
		},
		
		setupCollection: function(){
			 
			var __this = this;
			
			intEl = $( 'meta[ data-collection ]' ); 
			
			if ( intEl.length ) {
				
				this.popupCollection = intEl.first();
				
				this.popupProduct.data( 'data-collection', this.popupCollection );
				
				$.extend( this.popupCollection, PopupCollection );
				
				this.popupCollection.init( __this );
				
			}
			
		},
		
		setupGeneral: function(){
			
			var __this = this;
			
			intEl = $( 'meta[ data-general ]' );
			
			if ( intEl.length ) {
				
				this.popupGeneral = intEl.first();
				
				this.popupGeneral.data( 'data-general', this.popupGeneral );
				
				$.extend( this.popupGeneral, PopupNewsletter );
				
				this.popupGeneral.init( __this );
				
			}
			
		},
		
		setupNewsletter: function(){
			
			var __this = this;
			
			intEl = $( 'meta[ data-newsletter ]' );
			
			if ( intEl.length ) {
				
				this.popupNewsletter = intEl.first();
				
				this.popupNewsletter.data( 'data-newsletter', this.popupProduct );
				
				$.extend( this.popupNewsletter, PopupNewsletter );
				
				this.popupNewsletter.init( __this );
				
			}
			
		},
		
		setupShipping: function(){
			
			var __this = this;
			
			intEl = $( 'meta[ data-shipping ]' );
			
			if ( intEl.length ) {
				
				this.popupShipping = intEl.first();
				
				this.popupShipping.data( 'data-shipping', this.popupShipping );
				
				// t
				$.extend( this.popupShipping, PopupNewsletter ); 
				
				this.popupShipping.init( __this );
				
			}
			
		},
		
		testPopups: function( force ){
			
			var __this = this;
			
			compare = typeof force != 'undefined' ? 9999999999999: new Date().getTime();
			
			//console.log( 'compare:    ' + compare );
			
			intPop = null;
			
			// check newsletter
			
			if( this.popupNewsletter != null ) {
				
				//console.log( 'cookie? ' + this.popupNewsletter.hasCookie() )
			
				if( ! this.popupNewsletter.hasCookie() ) {
					
					intPop = this.popupNewsletter;
					
				} else {
					
					intExp = this.popupNewsletter.getExpires();
					
					if ( intExp < compare ) { 
						
						console.log( 'newsletter' );
						
						compare = intExp;
						
						intPop = this.popupNewsletter;
						
					} else {
						
						this.popupNewsletter.runTimer();
						
					}
					
				}
				
			}
			
			// run shipping
			
			if( this.popupShipping != null ) {
				
				console.log( 'cookie? ' + this.popupShipping.hasCookie() )
			
				if( ! this.popupShipping.hasCookie() ) {
					
					intPop = this.popupShipping;
					
				} else {
					
					//console.log( 'has cookie' );
					
					intExp = this.popupShipping.getExpires();
					
					if ( intExp < compare ) { 
						
						compare = intExp;
						
						intPop = this.popupShipping;
						
					} else {
						
						this.popupShipping.runTimer();
						
					}
					
				}
				
			}
			
			// run shipping
			
			if( this.popupGeneral != null ) {
			
				if( ! this.popupGeneral.hasCookie() ) {
					
					intPop = this.popupGeneral;
					
				} else {
					
					//console.log( 'has cookie' );
					
					intExp = this.popupGeneral.getExpires();
					
					if ( intExp < compare ) { 
						
						compare = intExp;
						
						intPop = this.popupGeneral;
						
					} else {
						
						this.popupGeneral.runTimer();
						
					}
					
				}
				
			}
			
			// check products
			
			if( this.popupProduct != null ) { // run product

				if( this.popupProduct.hasCookie() && ! this.popupProduct.checkPage() ) { // && is not the same product page!!!
								
					intExp = this.popupProduct.getExpires();
					
					console.log( intExp + '    product expires' )
					
					if ( intExp < compare ) { 
						
						console.log( 'product' )
						
						compare = intExp;
						
						intPop = this.popupProduct;
						
					} else {
						
						this.popupProduct.runTimer();
						
					}
				
				}
				
			} else { console.log( 'product null!' ); }
			
			// check collection
			
			if( this.popupCollection != null ) { // run product

				if( this.popupCollection.hasCookie() && ! this.popupCollection.checkPage() ) { // && is not the same product page!!!
								
					intExp = this.popupCollection.getExpires();
					
					if ( intExp < compare ) { 
						
						compare = intExp;
						
						intPop = this.popupCollection;
						
					} else {
						
						this.popupCollection.runTimer();
						
					}
				
				}
				
			} else { console.log( 'collection null!' ); }
			
			// run category
			
			if( intPop != null ) {
			
				intPop.runPopup();	
				
			}
			
		}, 
		
		updateTimer: function( type ){
			
			if( this.popupNewsletter != null ){	
				
				this.popupNewsletter.pushExpireValue( );
				
				this.popupNewsletter.runTimer( );
				
			}
			
			if( this.popupShipping != null ){	
				
				this.popupShipping.pushExpireValue( );
				
				this.popupShipping.runTimer( );
				
			}
			
			if( this.popupProduct != null && type != 'product' )	{
				
				this.popupProduct.pushExpireValue( 1 );
				
				this.popupProduct.runTimer( );
				
			}
			
			if( this.popupCollection != null && type != 'collection' )	{
				
				this.popupCollection.pushExpireValue( 2 );
				
				this.popupCollection.runTimer( );
				
			}
			
		},
		
		compareTime: function( num ){
			
			diff = num - new Date().getTime();
			
			return diff; 
			
		}
		
	}
	
	/*
		
		
		
		CART
		
		
		
		*/
	
	var PopupCart = {
		
		init: function( root ){
			
			var __this = this;
			
			this.root = root;
			
			this.cookie = null;
			
			this.timer = null;
			
			this.expireTime = 0;
			
			this.isCart = 0;
			
			console.log( this.isCart )
			
			this.testCart();
			
			if( $.cookie( this.attr( 'data-cookie' ) ) ) this.testCookie();
			
			console.log( this.isCart )
			
			$( document ).on( 'mouseleave', function( e ){
				
				if( e.clientY <= 0 || e.clientX <= 0 || ( e.clientX >= window.innerWidth || e.clientY >= window.innerHeight ) ) __this.runCookie();
				
			} )
			
		}, 
		
		testCart: function(){
			
			var __this = this;
			
			$.getJSON( '/cart.js', function( data ) {

				// console.log( 'There are now ' + data.item_count + ' items in the cart.' );
				
				if ( data.item_count > 0 ) __this.isCart = 1;
				
			} );
			
		},
		
		testCookie: function(){
			
			var __this = this;	
			
			this.cookie = JSON.parse( $.cookie( this.attr( 'data-cookie' ) ) );
			
		}, 
		
		expireValue: function(){
			
			this.expireTime = parseInt( this.attr( 'data-expires' ) );
			
			var now = new Date().getTime();
			
			var intOff = 1000 * 60 * 60 * this.expireTime
			
			var expireDate = now + intOff;
			
			return expireDate;	
			
		},
		
		pushExpireValue: function( cnt ){
		
			var __this = this;
			
			if( typeof cnt == 'undefined' ) cnt = 0;
			
			if ( this.hasCookie() ) {
				
				expireDate = ( this.cookie.expire > new Date().getTime() ) ? parseInt( this.cookie.expire ) + ( 1000 * 60 * ( 10 + cnt ) ) :  parseInt( new Date().getTime() ) + ( 1000 * 60 * ( 10 + cnt ) ); // need to set minutes (hardcoded 10)
				
				$.cookie( this.attr( 'data-cookie' ), '{ "data": "' + this.attr( 'data-popup' ) + '", "expire": "' + expireDate + '" }' );
				
			} else {
				
				$.cookie( this.attr( 'data-cookie' ), '{ "data": "' + this.attr( 'data-popup' ) + '", "expire": "' + __this.expireValue() + '" }' );
			
				this.cookie = JSON.parse( $.cookie( this.attr( 'data-cookie' ) ) );
				
			}
			
		},
		
		getExpires: function(){ // returns the interim expires value
			
			var __this = this;
			
			return this.cookie.expire;
			
		}, 
		
		testPopup: function(){
			
			var __this = this;
			
		}, 
		
		hasCookie: function(){
			
			if( this.cookie != null ) return 1;
			
			else return 0;
			
		}, 
		
		runCookie: function(){
			
			var __this = this;
			
			var run = 0;
			
			if( ! this.hasCookie() ) run = 1;
			
			else {
				
				if ( this.cookie.expire < new Date().getTime() ) run = 1;
				
			}
			
			console.log( 'should run? ' + run );
			
			if( run && __this.isCart ) {
				
				console.log( 'here' );
				
				this.activatePopup();
				
				$.cookie( __this.attr( 'data-cookie' ), '{ "data": "---", "expire": "' + __this.expireValue() + '" }' );
				
				__this.cookie = JSON.parse( $.cookie( __this.attr( 'data-cookie' ) ) );
				
				__this.root.updateTimer();
				
			}
			
		},
		
		runPopup: function(){
			
			var __this = this;
			
			setTimeout( function(){
				
				__this.activatePopup();
				
				$.cookie( __this.attr( 'data-cookie' ), '{ "data": "---", "expire": "' + __this.expireValue() + '" }' );
			
				__this.cookie = JSON.parse( $.cookie( __this.attr( 'data-cookie' ) ) );
				
				__this.root.updateTimer();
				
			}, parseInt( __this.attr( 'data-timer' ) * 1000 ) ); 
			
		}, 
		
		activatePopup: function(){
			
			var __this = this;
			
			intColl = this;
			
			if( intColl.length ){
				
				intDiv = $( '<div class="popup popup-alt"></div>' );
				intDiv.appendTo( 'body' );
			
				h2 = intColl.attr( 'data-link' ) != '' ? $('<h2 class="SectionHeader__Heading"><a href="' + intColl.attr( 'data-link' ) +'">' + intColl.attr( 'data-heading' ) + '</a></h2>') : $('<h2 class="SectionHeader__Heading">' + intColl.attr( 'data-heading' ) + '</h2>');
				
				btn = intColl.attr( 'data-link' ) != '' ? $( '<a href="' + intColl.attr( 'data-link' ) +'" class="btn Button Button--primary">' + intColl.attr( 'data-link-text' ) + '</a>' ) : '';
				
				intHtml = $( '<div class="popup-container"></div>' );
				
				h2.appendTo( intHtml );
				
				$( '<a href="#close">x</a>' )
					.appendTo( intHtml )
					.on( 'click', function(){
						
						$( this ).closest( '.popup' ).removeClass( 'active' );
						
					} );
				
				if( intColl.attr( 'data-content' ) != '' ) $( '<div>' + intColl.attr( 'data-content' ) + '</div>' ).appendTo( intHtml );
				
				if ( btn != '' ) btn.appendTo( intHtml );
				
				intHtml.appendTo( intDiv );
				
				intHtml.css( 'background-image' , 'url(' + intColl.attr( 'data-image' ) + ')' );
				
				intDiv[0].offsetHeight;
				
				intDiv.addClass( 'active' );
					
			}
				
			
		},
		
		runTimer: function(){
			
			var __this = this;
			
			clearTimeout( this.timer );
			
			if( this.hasCookie() ) {
				
				if ( this.cookie.expire > new Date().getTime() ) {
					
					exp = parseInt( this.cookie.expire - new Date().getTime() );
			
					this.timer = setTimeout( function(){
						
						__this.runPopup();
						
					}, exp );
					
				}
				
			}
			
		}
		
	}
	
	/*
		
		
		
		NEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTER
		NEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTER
		NEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTERNEWSLETTER
		
		
		
		*/
	
	var PopupNewsletter = {
		
		init: function( root ){
			
			var __this = this;
			
			this.root = root;
			
			this.cookie = null;
			
			this.timer = null;
			
			this.expireTime = 0;
			
			if( $.cookie( this.attr( 'data-cookie' ) ) ) this.testCookie();
			
		}, 
		
		testCookie: function(){
			
			var __this = this;	
			
			//console.log( $.cookie( this.attr( 'data-cookie' ) ) )
			
			this.cookie = JSON.parse( $.cookie( this.attr( 'data-cookie' ) ) );
			
		}, 
		
		expireValue: function(){
			
			this.expireTime = parseInt( this.attr( 'data-expires' ) );
			
			var now = new Date().getTime();
			
			var intOff = 1000 * 60 * 60 * this.expireTime
			
			var expireDate = now + intOff;
			
			//console.log( 'now   ' + now + '   - expireTime   ' + this.expireTime + '   - expireDate   ' + expireDate );
			
			return expireDate;	
			
		},
		
		pushExpireValue: function( cnt ){
		
			var __this = this;
			
			if( typeof cnt == 'undefined' ) cnt = 0;
			
			if ( this.hasCookie() ) {
				
				expireDate = ( this.cookie.expire > new Date().getTime() ) ? parseInt( this.cookie.expire ) + ( 1000 * 60 * ( 10 + cnt ) ) :  parseInt( new Date().getTime() ) + ( 1000 * 60 * ( 10 + cnt ) ); // need to set minutes (hardcoded 10)
				
				$.cookie( this.attr( 'data-cookie' ), '{ "data": "' + this.attr( 'data-popup' ) + '", "expire": "' + expireDate + '" }' );
				
			} else {
				
				$.cookie( this.attr( 'data-cookie' ), '{ "data": "' + this.attr( 'data-popup' ) + '", "expire": "' + __this.expireValue() + '" }' );
			
				this.cookie = JSON.parse( $.cookie( this.attr( 'data-cookie' ) ) );
				
			}
			
		},
		
		getExpires: function(){ // returns the interim expires value
			
			var __this = this;
			
			return this.cookie.expire;
			
		}, 
		
		testPopup: function(){
			
			var __this = this;
			
		}, 
		
		hasCookie: function(){
			
			if( this.cookie != null ) return 1;
			
			else return 0;
			
		}, 
		
		runPopup: function(){
			
			var __this = this;
			
			setTimeout( function(){
				
				__this.activatePopup();
				
				$.cookie( __this.attr( 'data-cookie' ), '{ "data": "---", "expire": "' + __this.expireValue() + '" }' );
			
				__this.cookie = JSON.parse( $.cookie( __this.attr( 'data-cookie' ) ) );
				
				__this.root.updateTimer();
				
			}, parseInt( __this.attr( 'data-timer' ) * 1000 ) ); 
			
		}, 
		
		activatePopup: function(){
			
			var __this = this;
			
			intColl = this;
			
			if( intColl.length ){
				
				intDiv = $( '<div class="popup popup-alt"></div>' );
				intDiv.appendTo( 'body' );
			
				h2 = intColl.attr( 'data-link' ) != '' ? $('<h2 class="SectionHeader__Heading"><a href="' + intColl.attr( 'data-link' ) +'">' + intColl.attr( 'data-heading' ) + '</a></h2>') : $('<h2 class="SectionHeader__Heading">' + intColl.attr( 'data-heading' ) + '</h2>');
				
				btn = intColl.attr( 'data-link' ) != '' ? $( '<a href="' + intColl.attr( 'data-link' ) +'" class="btn CollectionItem__Link Button">' + intColl.attr( 'data-link-text' ) + '</a>' ) : '';
				
				intHtml = $( '<div class="popup-container"></div>' );
				
				h2.appendTo( intHtml );
				
				$( '<a href="#close">x</a>' )
					.appendTo( intHtml )
					.on( 'click', function(){
						
						$( this ).closest( '.popup' ).removeClass( 'active' );
						
					} );
				
				if( intColl.attr( 'data-content' ) != '' ) $( '<div>' + intColl.attr( 'data-content' ) + '</div>' ).appendTo( intHtml );
				
				if ( btn != '' ) btn.appendTo( intHtml );
				
				$( '.Header__LogoImage--primary' ).clone().appendTo ( intHtml );
				
				intHtml.appendTo( intDiv );
				
				intHtml.css( 'background-image' , 'url(' + intColl.attr( 'data-image' ) + ')' );
				
				intDiv[0].offsetHeight;
				
				intDiv.addClass( 'active' );
					
			}
				
			
		},
		
		runTimer: function(){
			
			var __this = this;
			
			clearTimeout( this.timer );
			
			if( this.hasCookie() ) {
				
				//console.log( 'EXPIRES:   ' + this.cookie.expire );
				
				if ( this.cookie.expire > new Date().getTime() ) {
					
					exp = parseInt( this.cookie.expire - new Date().getTime() );
			
					this.timer = setTimeout( function(){
						
						__this.runPopup();
						
					}, exp );
					
				}
				
			}
			
		}
		
	}
	
	/*
		
		
		
		PRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCT
		PRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCT
		PRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCTPRODUCT
		
		
		
		*/
	
	var PopupProduct = {
		
		init: function( root ){
			
			var __this = this;
			
			this.root = root;
			
			this.cookie = null;
			
			this.prodJSON = null;
			
			this.timer = null;
			
			if( $.cookie( 'data-product' ) ) this.testCookie();
			
			this.testPage();
			
			// this.testPopup();
			
		}, 
		
		testCookie: function(){
			
			var __this = this;	
			
			//console.log( $.cookie( 'data-product' ) );
			
			this.cookie = JSON.parse( $.cookie( 'data-product' ) );
			
		},
		
		testPage: function(){
			
			var __this = this;
			
			// todo: fix this up so it only works on the product page
			
			if( $( '#ProductJson-product-template' ).length && $( 'meta[data-product]' ).length ) {
				
				this.prodJSON = JSON.parse( $( '#ProductJson-product-template' ).text() );
				
				$( 'meta[data-product]' ).each( function(){ // has a list of products
					
					//console.log( __this.prodJSON.id + '==' + $( this ).attr( 'data-product' ) );
					
					if ( __this.prodJSON.id == $( this ).attr( 'data-product' ) ) { // user on the product page
						
						if ( ! __this.hasCookie() ) { 
							
							// doesn't have a product list set up
							
							//console.log( 'product cookie: ' )
							
							$.cookie( 'data-product', '{ "data": "' + __this.prodJSON.id + '", "expire": "' + __this.expireValue() + '" }' );
							
							__this.cookie = JSON.parse( $.cookie( 'data-product' ) );
							
						} else { 
							
							// product list set up, if product isn't in list, add it.
							
							intData = __this.cookie.data;
							
							intArr = intData.split( '-' );
							
							//console.log( 'array   ' + $.inArray( __this.prodJSON.id, intArr ) );
							
							if( $.inArray( __this.prodJSON.id, intArr ) === -1 ) { 
								
								// is not in array, so is added
								
								intComm = intArr.length == 0 ? '' : '-';
								
								intData = intData + intComm + __this.prodJSON.id;
								
								//console.log( intData )
								
								$.cookie( 'data-product', '{"data": "' + intData + '", "expire": "' + __this.getExpires() + '" }' );
								
								__this.cookie = JSON.parse( $.cookie( 'data-product' ) );
								
							} else {  } // is in array already
							
						}
						
					}
					
				} );
				
			}
			
		}, 
		
		expireValue: function(){
			
			this.expireTime = parseInt( this.attr( 'data-expires' ) );
			
			var now = new Date().getTime();
			
			//console.log( now + '  - NOW' );
			
			var expireDate = now + ( 1000 * 60 * 60 * this.expireTime );
			
			return expireDate;	
			
		},
		
		getExpires: function(){
			
			var __this = this;
			
			return this.cookie.expire;
			
		}, 
		
		pushExpireValue: function( cnt ){
		
			var __this = this;
			
			if( typeof cnt == 'undefined' ) cnt = 0;
			
			if ( this.hasCookie() ) {
				
				expireDate = ( this.cookie.expire > new Date().getTime() ) ? parseInt( this.cookie.expire ) + ( 1000 * 60 * ( 10 + cnt ) ) :  parseInt( new Date().getTime() ) + ( 1000 * 60 * ( 10 + cnt ) ); // need to set minutes (hardcoded 10)
				
				$.cookie( 'data-product', '{ "data": "' + this.cookie.data +'", "expire": "' + expireDate + '" }' );
				
				this.cookie = JSON.parse( $.cookie( 'data-product' ) );
				
			} else {
				
				
				
			}
			
		},
		
		testPopup: function(){
			
			var __this = this;
			
		}, 
		
		hasCookie: function(){
			
			if( this.cookie != null ) return 1;
			
			else return 0;
			
		}, 
		
		runPopup: function(){
			
			var __this = this;
			
			setTimeout( function(){
				
				console.log( 'running product popup:' + parseInt( __this.attr( 'data-timer' ) * 1000 ) );
				
				__this.activatePopup();
				
				__this.root.updateTimer( 'product' ); 
				
				__this.splitProduct();
			
			}, parseInt( __this.attr( 'data-timer' ) * 1000 ) ); 
			
		}, 
		
		activatePopup: function(){
			
			var __this = this;
			
			intData = this.cookie.data;
			
			intArr = intData.split( '-' );
			
			intProd = this.parent().find( ' > div[data-product="' + intArr[ 0 ] + '"]' );
			
			if( intProd.length ){
			
				intDiv = $( '<div class="popup"></div>' );
				intDiv
					.append( intProd.html( ) )
					.appendTo( 'body' );
					
			}
				
			
		},
		
		runTimer: function(){ // runs if 
			
			var __this = this;
			
			clearTimeout( this.timer );
			
			if( this.hasCookie() ) {
				
				if ( this.cookie.expire > new Date().getTime() ) {
					
					expireVal = this.cookie.expire - new Date().getTime();
			
					this.timer = setTimeout( function(){
						
						__this.runPopup();
						
					}, expireVal );
					
				}
				
			}
			
		},
		
		checkPage: function(){
			
			if( this.prodJSON != null ){
				
				if( this.prodJSON.id == this.cookie.data.split( '-' )[0] ) return 1;
				
				else return 0;
			
			} else return 0;	
			
		},
		
		splitProduct: function(){
			
			var __this = this;
			
			intData = this.cookie.data;
			
			console.log( $.cookie( 'data-product' ) + '  ||  ' + intData );
			
			intArr = intData.split( '-' );
			
			intArr.splice(0, 1);
			
			console.log( intArr.length + '  prod cookie length' );
			
			if( intArr.length > 0 ) {
				
				intStr = '';
				
				for ( x = 0; x < intArr.length; x++ ) {
					
					intComm = x == 0 ? '' : '-';
					
					intStr = intStr + intComm + intArr[ x ];
					
				}
				
				$.cookie( 'data-product', '{"data": "' + intStr + '", "expire": "' + this.expireValue() + '" }' );
				
				console.log( $.cookie( 'data-product' ) );
					
			} else {
				
				console.log( 'remove cookie' );
				
				//document.cookie = "cookiename=data-product; expires= Thu, 21 Aug 2014 20:00:00 UTC; path=/ "
				
				//$.cookie( 'data-product', null, { expires: -1 } );
				
				$.removeCookie( 'data-product' );
				
			}
			
			console.log( $.cookie( 'data-product' ) );
			
		}
		
	}
	
	
	/*
		
		COLLECTIONS
		
	*/
	
	var PopupCollection = {
		
		init: function( root ){
			
			var __this = this;
			
			this.root = root;
			
			this.cookie = null;
			
			this.timer = null;
			
			if( $.cookie( 'data-collection' ) ) this.testCookie();
			
			this.testPage();
			
		}, 
		
		testCookie: function(){
			
			var __this = this;	
			
			console.log( $.cookie( 'data-collection' ) );
			
			this.cookie = JSON.parse( $.cookie( 'data-collection' ) );
			
		},
		
		testPage: function(){
			
			var __this = this;
			
			// todo: fix this up so it only works on the product page
			
			if( $( 'body' ).is( '.template-collection' ) && $( 'meta[data-collection]' ).length ) {
				
				$( 'meta[data-collection]' ).each( function(){ // has a list of products
					
					//console.log( $( 'link[rel = "canonical"]' ).attr( 'href' ) + '     ' + $( this ).attr( 'data-collection' ) + '      ' + $( 'body' ).attr( 'id' ) + '      ' + $( this ).attr( 'data-collection' ).indexOf( $( 'body' ).attr( 'id' ) ) + '    console' );
					
					if ( $( 'link[rel = "canonical"' ).attr( 'href' ).indexOf( $( this ).attr( 'data-collection' ) ) > -1 ) { 
						
						if ( ! __this.hasCookie() ) { 
							
							// doesn't have a product list set up
							
							console.log( 'product collection: ' )
							
							$.cookie( 'data-collection', '{ "data": "' + $( this ).attr( 'data-collection' ) + '", "expire": "' + __this.expireValue() + '" }' );
							
							__this.cookie = JSON.parse( $.cookie( 'data-collection' ) );
							
						} else { 
							
							// product list set up, if product isn't in list, add it.
							
							intData = __this.cookie.data;
							
							intArr = intData.split( '|' );
							
							if( $.inArray( $( this ).attr( 'data-collection' ), intArr ) === -1 ) { 
								
								// is not in array, so is added
								
								intComm = intArr.length == 0 ? '' : '|';
								
								intData = intData + intComm + $( this ).attr( 'data-collection' );
								
								console.log( intData )
								
								$.cookie( 'data-collection', '{"data": "' + intData + '", "expire": "' + __this.getExpires() + '" }' );
								
								__this.cookie = JSON.parse( $.cookie( 'data-product' ) );
								
							} else {  } // is in array already
							
						}
						
					}
					
				} );
				
			}
			
		}, 
		
		expireValue: function(){
			
			this.expireTime = parseInt( this.attr( 'data-expires' ) );
			
			var now = new Date().getTime();
			
			console.log( now + '  - NOW' );
			
			var expireDate = now + ( 1000 * 60 * 60 * this.expireTime );
			
			return expireDate;	
			
		},
		
		getExpires: function(){
			
			var __this = this;
			
			return this.cookie.expire;
			
		}, 
		
		pushExpireValue: function( cnt ){
		
			var __this = this;
			
			if( typeof cnt == 'undefined' ) cnt = 0;
			
			if ( this.hasCookie() ) {
				
				expireDate = ( this.cookie.expire > new Date().getTime() ) ? parseInt( this.cookie.expire ) + ( 1000 * 60 * ( 10 + cnt ) ) :  parseInt( new Date().getTime() ) + ( 1000 * 60 * ( 10 + cnt ) ); // need to set minutes (hardcoded 10)
				
				$.cookie( 'data-collection', '{ "data": "' + this.cookie.data +'", "expire": "' + expireDate + '" }' );
				
				this.cookie = JSON.parse( $.cookie( 'data-collection' ) );
				
			} else {
				
				
				
			}
			
		},
		
		testPopup: function(){
			
			var __this = this;
			
		}, 
		
		hasCookie: function(){
			
			if( this.cookie != null ) return 1;
			
			else return 0;
			
		}, 
		
		runPopup: function(){
			
			var __this = this;
			
			setTimeout( function(){
				
				__this.activatePopup();
				
				__this.root.updateTimer( 'collection' ); 
				
				__this.splitProduct();
			
			}, parseInt( __this.attr( 'data-timer' ) * 1000 ) ); 
			
		}, 
		
		activatePopup: function(){
			
			var __this = this;
			
			intData = this.cookie.data;
			
			intArr = intData.split( '|' );
			
			// console.log( intArr[ 0 ] );
			
			intColl = $( 'meta[data-collection="' + intArr[ 0 ] + '"]' );
			
			if( intColl.length ){
				
				intDiv = $( '<div class="popup popup-alt"></div>' );
				intDiv.appendTo( 'body' );
			
				h2 = $('<h2 class="SectionHeader__Heading"><a href="' + intColl.attr( 'data-collection' ) +'">' + intColl.attr( 'data-title' ) + '</a></h2>');
				
				btn = $( '<a href="' + intColl.attr( 'data-collection' ) +'" class="btn Button Button--primary">' + intColl.attr( 'data-button' ) + '</a>' );
				
				intHtml = $( '<div class="popup-container"></div>' );
				
				h2.appendTo( intHtml );
				
				btn.appendTo( intHtml );
				
				$( '<a href="#close">x</a>' )
					.appendTo( intHtml )
					.on( 'click', function(){
						
						$( this ).closest( '.popup' ).removeClass( 'active' );
						
					} );
				
				intHtml.appendTo( intDiv );
				
				intHtml.css( 'background-image' , 'url(' + intColl.attr( 'data-image' ) + ')' );
				
				intDiv[0].offsetHeight;
				
				intDiv.addClass( 'active' );
					
			}
			
		},
		
		runTimer: function(){ // runs if 
			
			var __this = this;
			
			clearTimeout( this.timer );
			
			if( this.hasCookie() ) {
				
				if ( this.cookie.expire > new Date().getTime() ) {
					
					expireVal = this.cookie.expire - new Date().getTime();
			
					this.timer = setTimeout( function(){
						
						__this.runPopup();
						
					}, expireVal );
					
				}
				
			}
			
		},
		
		checkPage: function(){
			
			if( $( 'body' ).is( 'template-collection' ) ){
				
				if( $( 'link' ).attr( 'href' ).indexOf( this.cookie.data.split( '-' )[0] ) > -1 ) return 1;
				
				else return 0;
			
			} else return 0;	
			
		},
		
		splitProduct: function(){
			
			var __this = this;
			
			intData = this.cookie.data;
			
			intArr = intData.split( '|' );
			
			intArr.splice(0, 1);
			
			console.log( intArr.length + '  prod cookie length' );
			
			if( intArr.length > 0 ) {
				
				intStr = '';
				
				for ( x = 0; x < intArr.length; x++ ) {
					
					intComm = x == 0 ? '' : '|';
					
					intStr = intStr + intComm + intArr[ x ];
					
				}
				
				$.cookie( 'data-collection', '{"data": "' + intStr + '", "expire": "' + this.expireValue() + '" }' );
					
			} else {
				
				$.removeCookie( 'data-collection' );
				
			}
			
		}
		
	}
	
	$( document ).ready( function(){
		
		Popup.init();
		
	} );
	
	var targetNodes         = $( '#section-footer' );
	var MutationObserver    = window.MutationObserver || window.WebKitMutationObserver;
	var myObserver          = new MutationObserver (mutationHandler);
	var obsConfig           = { childList: true, characterData: true, attributes: true, subtree: true };
	
	//--- Add a target node to the observer. Can only add one node at a time.
	targetNodes.each ( function () {
		
	    myObserver.observe (this, obsConfig);
	    
	} );
	
	function mutationHandler (mutationRecords) {
		
    	$( '.klaviyo-form:not( .done )' ).each( function(){
        	
        	console.log( 'found form' )
	
			$( this )
				.addClass( 'done' );
				
			$( this ).find( 'form, .qYFrN, .kjNJFx, .brebrf' )
				.removeClass( 'brebrf' )
				.removeClass( 'kjNJFx' )
				.removeClass( 'qYFrN' );
			
			$( this ).find( 'div' ).attr( 'class', '' );
			
			$( this ).find( 'p, strong' ).attr( 'style', '' );
			
			$( this ).find( 'input, button' )
				.removeClass( 'jEhxBR' )
				.removeClass( 'FUXqS' )
				.removeClass( 'fsIKy' )
				.removeClass( 'drQERt' )
				.removeClass( 'bsFeqo' ) 
				.removeClass( 'kiiqgw' )
				.removeClass( 'izyMjd' )
				.removeClass( 'drQERt' )
				.removeClass( 'idnfEc' )
				.removeClass( 'jcZgug' )
				.removeClass( 'hTOiSK' )
				
			$( this ).find( 'button' )
				.addClass( 'Form__Submit' )
				.addClass( 'Button' )
				.addClass( 'Button--primary' )
				
			$( this ).find( '[class*="TextInput"]' )
				.attr( 'type', 'text' )
				.css( 'margin-top', '10px' )
				.addClass( 'Form__Input' )
			
		} );
		
	 }
	
})(jQuery);
